import React from 'react'
import {
    FACEBOOK_CARD_IMAGE,
    FACEBOOK_PAGE_URL,
    YOUTUBE_CARD_IMAGE,
    YOUTUBE_CHANNEL_URL,
} from '../../config/socialLinks'

const accent = '#e53935'
const accentFb = '#1877f2'
const cardShadow = '0 12px 40px rgba(15, 23, 42, 0.08), 0 0 0 1px rgba(15, 23, 42, 0.06)'

function SocialEmbedsOne() {
    return (
        <section
            className="space position-relative overflow-hidden"
            style={{
                background: 'linear-gradient(180deg, #fdfcfa 0%, #f5f1eb 45%, #f0ebe3 100%)',
            }}
        >
            <div
                aria-hidden="true"
                className="position-absolute"
                style={{
                    top: '-20%',
                    right: '-10%',
                    width: 'min(480px, 75vw)',
                    height: 'min(480px, 75vw)',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle at 40% 40%, rgba(229, 57, 53, 0.12), transparent 55%)',
                    pointerEvents: 'none',
                }}
            />
            <div
                aria-hidden="true"
                className="position-absolute"
                style={{
                    bottom: '-15%',
                    left: '-8%',
                    width: 'min(420px, 70vw)',
                    height: 'min(420px, 70vw)',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle at 60% 50%, rgba(24, 119, 242, 0.1), transparent 52%)',
                    pointerEvents: 'none',
                }}
            />

            <div className="container position-relative" style={{ zIndex: 1 }}>
                <div className="row justify-content-center mb-40">
                    <div className="col-xl-10 col-lg-11 text-center">
                        <div className="title-area mb-10">
                            <span className="sub-title style1" style={{ letterSpacing: '0.1em' }}>
                                Stream &amp; stories
                            </span>
                            <h2 className="sec-title mb-15 heading" style={{ lineHeight: 1.15 }}>
                                Watch on YouTube, follow on Facebook
                            </h2>
                            <p className="sec-text mx-auto mb-0" style={{ maxWidth: 640, opacity: 0.88 }}>
                                Heritage walks, temple visits, and island stories — stay in the loop where we post
                                full episodes and community updates.
                            </p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-center" style={{ gap: 10 }}>
                            <span
                                style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.14em',
                                    padding: '6px 14px',
                                    borderRadius: 999,
                                    color: '#5c4033',
                                    background: 'rgba(229, 57, 53, 0.1)',
                                    border: '1px solid rgba(229, 57, 53, 0.25)',
                                }}
                            >
                                <span style={{ color: accent }} aria-hidden="true">
                                    ●
                                </span>{' '}
                                YouTube
                            </span>
                            <span
                                style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.14em',
                                    padding: '6px 14px',
                                    borderRadius: 999,
                                    color: '#1e3a5f',
                                    background: 'rgba(24, 119, 242, 0.1)',
                                    border: '1px solid rgba(24, 119, 242, 0.22)',
                                }}
                            >
                                <span style={{ color: accentFb }} aria-hidden="true">
                                    ●
                                </span>{' '}
                                Facebook
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row gy-5 align-items-stretch">
                    <div className="col-lg-6">
                        <div
                            className="h-100 d-flex flex-column"
                            style={{
                                background: '#fff',
                                borderRadius: 20,
                                boxShadow: cardShadow,
                                padding: '22px 22px 26px',
                            }}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-20 flex-wrap gap-2">
                                <h3 className="box-title mb-0 heading" style={{ fontSize: '1.25rem' }}>
                                    <i className="fab fa-youtube me-2" style={{ color: accent }} aria-hidden="true" />
                                    Channel spotlight
                                </h3>
                                <a
                                    href={YOUTUBE_CHANNEL_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="th-btn style3 th-icon"
                                    style={{ fontSize: 14, padding: '10px 18px' }}
                                >
                                    Open channel
                                </a>
                            </div>
                            <a
                                href={YOUTUBE_CHANNEL_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open Urumavahini on YouTube"
                                className="text-decoration-none d-block flex-grow-1 position-relative overflow-hidden"
                                style={{
                                    borderRadius: 14,
                                    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                                }}
                            >
                                <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }}>
                                    <img
                                        src={YOUTUBE_CARD_IMAGE}
                                        alt=""
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ objectFit: 'cover' }}
                                    />
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                        style={{
                                            background: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 100%)',
                                        }}
                                    >
                                        <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: 76,
                                                height: 76,
                                                borderRadius: '50%',
                                                background: 'rgba(255,255,255,0.95)',
                                                color: accent,
                                                fontSize: 28,
                                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                            }}
                                            aria-hidden="true"
                                        >
                                            <i className="fab fa-youtube" />
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="position-absolute bottom-0 start-0 w-100 px-3 pb-3 pt-5"
                                    style={{
                                        background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
                                    }}
                                >
                                    <p className="text-white fw-semibold mb-0" style={{ fontSize: '1.05rem' }}>
                                        Explore videos on YouTube
                                    </p>
                                    <p className="text-white small mb-0 mt-1" style={{ opacity: 0.9 }}>
                                        Heritage &amp; travel stories from Sri Lanka
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div
                            className="h-100 d-flex flex-column"
                            style={{
                                background: '#fff',
                                borderRadius: 20,
                                boxShadow: cardShadow,
                                padding: '22px 22px 26px',
                            }}
                        >
                            <div className="d-flex align-items-center justify-content-between mb-20 flex-wrap gap-2">
                                <h3 className="box-title mb-0 heading" style={{ fontSize: '1.25rem' }}>
                                    <i className="fab fa-facebook-f me-2" style={{ color: accentFb }} aria-hidden="true" />
                                    Page feed
                                </h3>
                                <a
                                    href={FACEBOOK_PAGE_URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="th-btn style3 th-icon"
                                    style={{ fontSize: 14, padding: '10px 18px' }}
                                >
                                    Visit page
                                </a>
                            </div>
                            <a
                                href={FACEBOOK_PAGE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Open Urumavahini on Facebook"
                                className="text-decoration-none d-block flex-grow-1 position-relative overflow-hidden"
                                style={{
                                    borderRadius: 14,
                                    boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
                                }}
                            >
                                <div style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }}>
                                    <img
                                        src={FACEBOOK_CARD_IMAGE}
                                        alt=""
                                        className="position-absolute top-0 start-0 w-100 h-100"
                                        style={{ objectFit: 'cover' }}
                                    />
                                    <div
                                        className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                        style={{
                                            background: 'linear-gradient(180deg, rgba(24, 119, 242, 0.12) 0%, rgba(0,0,0,0.35) 100%)',
                                        }}
                                    >
                                        <span
                                            className="d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: 76,
                                                height: 76,
                                                borderRadius: '50%',
                                                background: 'rgba(255,255,255,0.95)',
                                                color: accentFb,
                                                fontSize: 28,
                                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                            }}
                                            aria-hidden="true"
                                        >
                                            <i className="fab fa-facebook-f" />
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="position-absolute bottom-0 start-0 w-100 px-3 pb-3 pt-5"
                                    style={{
                                        background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
                                    }}
                                >
                                    <p className="text-white fw-semibold mb-0" style={{ fontSize: '1.05rem' }}>
                                        Connect on Facebook
                                    </p>
                                    <p className="text-white small mb-0 mt-1" style={{ opacity: 0.9 }}>
                                        Updates, photos, and community
                                    </p>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SocialEmbedsOne
